export function request(id, data) {
    return {
        type: 'TAGS_QUERY_REQUEST',
        id,
        data
    };
}

export function error(id, errors) {
    return {
        type: 'TAGS_QUERY_ERROR',
        errors,
        id
    };
}

export function finish(id, definitions) {
    return {
        type: 'TAGS_QUERY_FINISH',
        definitions,
        id
    };
}
